<template>
    <div id="partner-count" class="partner-coun">
        <span>partner-coun</span>
    </div>
</template>

<script>
    const log = new Log("Page/partner-coun");
    export default {
        name: "partner-count"
    }
</script>

<style lang="less">
    #partner-coun {
        position: relative;
        overflow: hidden;
        width: 100%;
        padding: 10px 0;
        border-radius: 5px;
        background-color: #ffffff
    }
</style>